import { comparePoint } from '../../utils/common';
import { cloneDeep } from 'lodash';
import { fabric } from 'fabric';

const getBoundingListPoint = (points) => {
  let left = Number.MAX_SAFE_INTEGER;
  let top = Number.MAX_SAFE_INTEGER;
  points.forEach((point) => {
    left = Math.min(left, point.x);
    top = Math.min(top, point.y);
  });
  return { left, top };
};

fabric.Polyline.prototype._render = (function(originalFn) {
  return function(ctx) {
    if (this.name === 'Path Arrow' || this.name === 'Arrow Line') {
      const points = cloneDeep(this.points);
      const arr = points.map((point, pointIndex) => ({
        x: point.x,
        y: point.y,
        isDuplicate: this.points.some((i, index) => comparePoint(point, i) && pointIndex !== index),
      }));

      const breakPoint = arr.findIndex((i) => !i.isDuplicate);
      const headArrowPoint = [...arr]
        .filter((i) => !i.isDuplicate)
        .map((point) => ({
          x: point.x,
          y: point.y,
        }));
      const pathPoint = [...arr].slice(0, breakPoint).map((point) => ({
        x: point.x,
        y: point.y,
      }));

      const { left: leftParent, top: topParent } = getBoundingListPoint(this.points);
      const { left: leftHead, top: topHead } = getBoundingListPoint(headArrowPoint);
      const { left: leftPath, top: topPath } = getBoundingListPoint(pathPoint);

      const headArrow = new fabric.Polyline([...headArrowPoint], {
        fill: this.stroke,
        stroke: this.stroke,
        strokeWidth: this.strokeWidth,
        opacity: this.opacity,
      });

      const path = new fabric.Polyline([...pathPoint], {
        fill: 'transparent',
        stroke: this.stroke,
        strokeWidth: this.strokeWidth,
        opacity: this.opacity,
        strokeDashArray: this.strokeDashArray,
        strokeLineCap: this.strokeLineCap,
      });
      let translateX = -this.width / 2 + (leftHead - leftParent) + headArrow.width / 2;
      let translateY = -this.height / 2 + (topHead - topParent) + headArrow.height / 2;

      ctx.translate(translateX, translateY);
      originalFn.call(headArrow, ctx);
      ctx.translate(-translateX, -translateY);
      translateX = -this.width / 2 + (leftPath - leftParent) + path.width / 2;
      translateY = -this.height / 2 + (topPath - topParent) + path.height / 2;
      ctx.translate(translateX, translateY);
      originalFn.call(path, ctx);
      ctx.translate(-translateX, -translateY);
      return this;
    }
    originalFn.call(this, ctx);
    return this;
  };
})(fabric.Polyline.prototype._render);
